export default __webpack_public_path__ + "static/media/multiRemoveBtn.dbae291c.svg";